import { createFileRoute } from "@tanstack/react-router";
import PoliciesForm from "../pages/PoliciesForm/PoliciesForm";
import { ActionType } from "../pages/PoliciesForm/PoliciesForm";

export const Route = createFileRoute("/_policies/edit-policy/$policyId")({
  validateSearch: (search: Record<string, unknown>) => ({
    action: (search.action as ActionType | undefined) ?? "edit",
  }),
  component: EditPolicyPage,
});

function EditPolicyPage() {
  const { policyId } = Route.useParams();
  const { action } = Route.useSearch();

  return <PoliciesForm actionType={action} policyId={policyId} />;
}
